import { useState, useEffect } from 'react';
import { loadingStageService } from './LoadingStageService';

const initialValue = loadingStageService.stage.getValue();
export const useLoading = () => {
  const [progress, setProgress] = useState(initialValue);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stageObserver = loadingStageService.stage.subscribe(setProgress);
    return () => {
      stageObserver.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (progress === loadingStageService.max) {
      setTimeout(() => {
        setLoading(false)
      }, 1500)
    }
  }, [progress]);

  return {
    loading,
    progress,
    next: loadingStageService.next,
  };
};
